<template>
    <div>
        <ModuleHeader :moduleName="mountedModule.name[$i18n.locale]"/>
        <div class="content-container" ref="moduleContainer">
            
        </div>
    </div>
</template>
<script>
import ModuleHeader from '@/components/ModuleHeader'

export default {
    name: 'ModuleContainer',
    components: {
        ModuleHeader
    },
    computed: {
        module(){
            return this.$route.params.module
        },
        mountedModule(){
            return this.$modules[this.$route.params.module]
        }
    },
    watch: {
        module(){
            this.unloadModule()
            this.loadModule(this.$modules[this.$route.params.module])
        }
    },
    mounted(){
        this.loadModule(this.$modules[this.$route.params.module])
    },
    beforeDestroy(){
        this.unloadModule()
    },
    methods: {
        loadModule(module){
            const mc = this.$refs.moduleContainer
            const anchor = document.createElement('div')
            anchor.id = module.anchor_id
            mc.appendChild(anchor)
            const scriptB = document.createElement('script')
            const scriptC = document.createElement('script')

            scriptB.setAttribute('src', module.bundle_url)
            scriptB.setAttribute('type', 'text/javascript')
            document.body.appendChild(scriptB)

            /* scriptC.setAttribute('src', module.chunks_url)
            scriptC.setAttribute('type', 'text/javascript')
            document.body.appendChild(scriptC) */
        },
        unloadModule(){
            const mc = this.$refs.moduleContainer
            mc.removeChild(mc.lastElementChild)
            document.body.removeChild(document.body.lastElementChild)
            //document.body.removeChild(document.body.lastElementChild)
        }
    }
}
</script>